module.exports = ".avatar { float: right; margin-left: 15px; width: 30px; height: 30px; border-radius: 50%; }\n\n.avatar-null { width: 30px !important; height: 30px !important; border-radius: 50%;  padding: 3px; color: #888; background: #eee; float: right; }\n\n.bg-orange { background: #9b3d1e; color: #fff; border-radius: 12px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/list-articles/list-articles.component.css
// module id = ./src/app/shared/list-articles/list-articles.component.css
// module chunks = main